import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcFlight(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m10.75 10.17-6.349 2.764a1.5 1.5 0 0 0-.901 1.367l7.25-.906v3.874l-2.5 1.5v1.516l3.884-1.4 3.678 1.374V18.78l-2.562-1.5v-3.885l7.25.906a1.5 1.5 0 0 0-.901-1.367l-6.349-2.763V4.75a1.25 1.25 0 1 0-2.5 0zm5.82 7.315c.46.27.742.762.742 1.295v2.199a1 1 0 0 1-1.35.937l-3.837-1.433-4.036 1.454a1 1 0 0 1-1.339-.94v-2.228a1.5 1.5 0 0 1 .728-1.286L9.25 16.42v-1.326l-6.126.766A1 1 0 0 1 2 14.867v-.557a3 3 0 0 1 1.803-2.751L9.25 9.188V4.75a2.75 2.75 0 1 1 5.5 0v4.438l5.448 2.371A3 3 0 0 1 22 14.309v.558a1 1 0 0 1-1.124.992l-6.126-.765v1.326z",
    clipRule: "evenodd"
  }));
}
var IcFlight = createNolIcon(/*#__PURE__*/forwardRef(SvgIcFlight));

export { IcFlight as I };
